var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading dark_bg"},[_c('p',[_c('img',{staticClass:"logo",attrs:{"src":_vm.valueWorth,"alt":""}}),_c('span',{staticClass:"logotxt",staticStyle:{"color":"black"}},[_vm._v("订单生成中......")])])])}
var staticRenderFns = []

export { render, staticRenderFns }